<template>
  <div>
    <h1 v-html="vueModel.Content.TitleSummary" />
    <!-- <pre class="_affix">
        {{ vueModel.Proposals[0].PaymentInformation }}
        {{ vueModel.Proposals[1].PaymentInformation }}
    </pre> -->
    <article>
      <label v-html="vueModel.Content.UseBetalingsServiceTextAndTooltip" />

      <div v-html="vueModel.Content.ImageBetalingsService" />
      <br />
      <br />

      <p class="text-question" v-html="vueModel.Content.LabelRegistrationNumber" />
      <Field
        v-model="vueModel.Data.AccountInformations.RegistrationNumber"
        :rules="'required|numeric|digits:4'"
        type="text"
        name="RegistrationNumber"
        label="Reg. nummer"
        maxlength="4"
        data-vv-validate-on="blur"
        data-test-registration-number
        @input="revalidate($event)"
      />
      <ValidationError name="RegistrationNumber" />

      <p class="text-question" v-html="vueModel.Content.LabelAccountNumber" />
      <Field
        v-model="vueModel.Data.AccountInformations.AccountNumber"
        :rules="'required|numeric|digits:10'"
        type="text"
        name="AccountNumber"
        label="Kontonummeret"
        maxlength="10"
        data-vv-validate-on="blur"
        data-test-account-number
        @input="revalidate($event)"
      />
      <ValidationError
        name="AccountNumber"
        :overrides="{
          digits:
            'Kontonummeret skal indeholde 10 cifre. Du skal evt. indtaste foranstillede nuller.'
        }"
      />

      <p><small v-html="vueModel.Content.LabelChargeMonthAnnotation" /></p>
      <p v-html="vueModel.Content.TextBetalingsservice" />
    </article>

    <hr />
    <h3 v-html="vueModel.Content.ConsentsAndDeclerationsTextAndTooltip" />

    <article v-if="!cprConsentAlreadyGiven" class="push-down checkbox-inline">
      <Field
        :model-value="vueModel.Data.Consents.AcceptCPRUsage"
        :rules="'required'"
        name="AcceptCPRUsage"
        :value="true"
        :unchecked-value="false"
        type="checkbox"
      >
        <input
          id="acceptCPRUsage"
          name="AcceptCPRUsage"
          type="checkbox"
          :value="vueModel.Data.Consents.AcceptCPRUsage"
          @click="vueModel.Data.Consents.AcceptCPRUsage = $event.target.checked"
        />
      </Field>
      <label for="acceptCPRUsage" class="bold-text" v-html="vueModel.Content.LabelCPRNumberUsage" />
      <div v-html="vueModel.Content.ContentCPRNumberUsage" />
      <ValidationError
        name="AcceptCPRUsage"
        :overrides="{ required: decodeHtml(vueModel.Content.ErrorAcceptTerms) }"
      />
    </article>

    <div>
      <article class="push-down checkbox-inline">
        <Field
          :model-value="vueModel.Data.Consents.AcceptInformationGathering"
          :unchecked-value="false"
          :rules="'required'"
          name="AcceptInformationGathering"
          type="checkbox"
        >
          <input
            id="acceptInformationGathering"
            name="AcceptInformationGathering"
            type="checkbox"
            :value="vueModel.Data.Consents.AcceptInformationGathering"
            @click="vueModel.Data.Consents.AcceptInformationGathering = $event.target.checked"
          />
        </Field>
        <label
          for="acceptInformationGathering"
          class="bold-text"
          v-html="vueModel.Content.LabelGetInformationsFromPreviousCompany"
        />
        <div v-html="vueModel.Content.ContentGetInformationsFromPreviousCompany" />
        <ValidationError
          name="AcceptInformationGathering"
          :overrides="{ required: decodeHtml(vueModel.Content.ErrorAcceptTerms) }"
        />
      </article>
    </div>

    <div v-if="vueModel.Content.LoadVerifyClaimHistoryCheckbox">
      <article class="push-down checkbox-inline">
        <Field
          :model-value="vueModel.Data.Consents.AcceptClaimHistory"
          :unchecked-value="false"
          :rules="'required'"
          name="AcceptClaimHistory"
          type="checkbox"
        >
          <input
            id="acceptClaimHistory"
            name="AcceptClaimHistory"
            type="checkbox"
            :value="vueModel.Data.Consents.AcceptClaimHistory"
            @click="vueModel.Data.Consents.AcceptClaimHistory = $event.target.checked"
          />
        </Field>
        <label
          for="acceptClaimHistory"
          class="bold-text"
          v-html="vueModel.Content.LabelVerifyClaimHistory"
        />
        <div v-html="vueModel.Content.ContentVerifyClaimHistory" />
        <ValidationError
          name="AcceptClaimHistory"
          :overrides="{ required: decodeHtml(vueModel.Content.ErrorAcceptTerms) }"
        />
        <div
          v-for="document in vueModel.Data.ClaimHistoryDocuments"
          :key="document.ProductName"
          class="padding-bottom"
        >
          <a class="link-icon-left" :href="document.Link" target="_blank">
            <span class="icon-download" />
            <u v-html="document.Title" />
          </a>
        </div>
      </article>
    </div>

    <div v-if="showAcceptConditions">
      <article class="push-down checkbox-inline">
        <Field
          :model-value="vueModel.Data.Consents.AcceptConditionsMet"
          :unchecked-value="false"
          :rules="'required'"
          name="AcceptConditionsMet"
          type="checkbox"
        >
          <input
            id="acceptConditionsMet"
            name="AcceptConditionsMet"
            type="checkbox"
            :value="vueModel.Data.Consents.AcceptConditionsMet"
            @click="vueModel.Data.Consents.AcceptConditionsMet = $event.target.checked"
          />
        </Field>
        <label
          for="acceptConditionsMet"
          class="bold-text"
          v-html="vueModel.Content.LabelConditionsCheckbox"
        />
        <div v-html="vueModel.Content.TextConditionsCheckbox" />
        <ValidationError
          name="AcceptConditionsMet"
          :overrides="{ required: decodeHtml(vueModel.Content.ErrorConditionsCheckbox) }"
        />
      </article>
    </div>

    <p class="summary-final-disclaimer" v-html="vueModel.Content.TextSummaryDisclaimer" />

    <article class="row">
      <div class="columns">
        <button class="button secondary" @click="back">Tilbage</button>
      </div>
      <div class="columns">
        <button class="button" @click="uploadFiles">
          {{ vueModel.Content.ConfirmationPageLinkModel.Text }}
        </button>
      </div>
    </article>

    <p v-html="vueModel.Content.TextCancellation" />
    <p v-html="vueModel.Content.LinkPersonalDataHandling" />

    <transition v-cloak name="modal">
      <v-modal
        :is-open="completeErrorModal"
        data-test="proposal-summary-complete-error-modal"
        @close="completeErrorModal = false"
      >
        <template #title>
          <h2 v-html="vueModel.Content.HeadlineCompleteErrorModal" />
        </template>
        <template #content>
          <div v-html="vueModel.Content.TextCompleteErrorModal" />
        </template>
        <template #buttons>
          <div>
            <a
              class="button large close-modal"
              @click="completeErrorModal = false"
              v-html="vueModel.Content.LabelButtonCompleteErrorModal"
            />
          </div>
        </template>
      </v-modal>
    </transition>

    <transition v-cloak name="modal" style="z-index: 10010">
      <v-modal
        :is-open="fileUploadModal"
        data-test="proposal-summary-file-upload-modal"
        @close="fileUploadModal = false"
      >
        <template #title>
          <h2 v-html="vueModel.Content.HeadlineFileUploadModal" />
        </template>
        <template #content>
          <div>
            <ul class="no-bullet">
              <li v-for="file in filesToUpload" :key="file">
                {{ file.name }}
              </li>
            </ul>
          </div>
        </template>
        <template #buttons>
          <div>
            <div class="row">
              <div class="small-12 columns">
                <div class="button secondary">
                  <div class="button primary file-progress-bar" />
                </div>
              </div>
            </div>
          </div>
        </template>
      </v-modal>
    </transition>
  </div>
</template>

<script>
import mixin from './CheckoutMixin.vue';
import ValidationError from '@/components/UI/ValidationError.vue';

import Utility from '@/common/UtilityFunctions.js';
import axios from 'axios';
import { forEach } from 'lodash';
import { FormContextKey } from 'vee-validate';
import { inject } from 'vue';

export default {
  name: 'Summary',
  components: {
    ValidationError
  },
  mixins: [mixin],
  props: {
    extVueModel: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  setup() {
    return { form: inject(FormContextKey, undefined) };
  },
  data() {
    return {
      config: {
        headers: {
          'Content-Type': 'application/json'
        }
      },
      completeErrorModal: false,
      cprConsentAlreadyGiven: false,
      fileUploadModal: false,
      filesToUpload: [],
      vueModel: this.extVueModel,
      showAcceptConditions: false
    };
  },
  computed: {
    paymentInformationJson() {
      var paymentJSON = {
        AccountInformations: {},
        PaymentSelections: [],
        Consents: {}
      };
      paymentJSON.AccountInformations = this.vueModel.Data.AccountInformations;
      for (var i in this.vueModel.Data.Proposals) {
        var proposal = {
          ProposalId: this.vueModel.Data.Proposals[i].Id,
          SelectedPaymentMethodModel: null,
          SelectedPaymentIntervalModel: {
            Description:
              this.vueModel.Data.Proposals[i].PaymentInformation.SelectedPaymentInterval
                .Description,
            Id: this.vueModel.Data.Proposals[i].PaymentInformation.SelectedPaymentInterval.Id
          }
        };
        paymentJSON.PaymentSelections.push(proposal);
        paymentJSON.Consents = this.vueModel.Data.Consents;
      }
      return paymentJSON;
    },
    filesInAnyProposal() {
      var filesExists = false;
      forEach(this.vueModel.Data.Proposals, (proposal) => {
        if (proposal.Files.length > 0) {
          filesExists = true;
          return false;
        }
      });
      return filesExists;
    },
    tagManagerProductData() {
      var products = {};
      forEach(this.vueModel.Data.Proposals, (proposal) => {
        products[this.getDanishProductTypeName(proposal.Type).toString()] = {
          terming: proposal.PaymentInformation.SelectedPaymentInterval.Description,
          paymentsperyear: this.getPaymentsPerYear(
            proposal.PaymentInformation.SelectedPaymentInterval.Id
          )
        };
      });
      return products;
    },
    tagManagerSavePaymentData() {
      return {
        event: 'track-event',
        eventCategory: 'betaling',
        eventAction: '02 - betaling - submit ok',
        eventLabel: '',
        eventValue: '0',
        eventNoninteraction: true,
        amount: this.vueModel.Data.TotalPrice.replace('.', '').replace(',', '.'),
        products: this.tagManagerProductData
      };
    }
  },
  beforeMount() {
    for (var i in this.vueModel.Data.Proposals) {
      this.vueModel.Data.Proposals[i].DefaultSelectedPaymentInterval =
        this.vueModel.Data.Proposals[i].PaymentInformation.SelectedPaymentInterval;
    }
  },
  mounted() {
    this.cprConsentAlreadyGiven = this.vueModel.Data.Consents.AcceptCPRUsage;
    Utility.pushToTagManager({
      event: 'track-event',
      eventCategory: 'betaling',
      eventAction: '01 - vis betaling',
      eventLabel: '',
      eventValue: '0',
      eventNoninteraction: true
    });
    this.setShowConditionsCheckbox();
  },
  methods: {
    decodeHtml: Utility.decodeHtml,
    back() {
      this.$emit('go-back');
    },
    savePayment() {
      return this.form.validate().then((result) => {
        if (result.valid) {
          $('#summary').addClass('done');
          axios
            .post(
              Utility.constants().API.checkout_save_payment,
              JSON.stringify(this.paymentInformationJson),
              this.config
            )
            .then(() => {
              this.dispatchEvent();
              Utility.pushToTagManager(this.tagManagerSavePaymentData);
              setTimeout(() => {
                window.location = this.vueModel.Data.ConfirmationPageURL;
              }, 500);
            })
            .catch(() => {
              this.completeErrorModal = true;
            });
        } else {
          this.scrollToFirstError();
        }
      });
    },
    uploadFiles() {
      this.form.validate().then((result) => {
        if (result.valid) {
          if (!this.filesInAnyProposal) {
            this.savePayment();
          } else {
            const uploadUrl = '/api/Checkout/uploaddocument?flowType=taxation';
            var formData = new FormData();
            forEach(this.vueModel.Data.Proposals, (proposal, proposalIndex) => {
              if (proposal.Files.length > 0) {
                this.filesToUpload = [];
                forEach(proposal.Files, (file, index) => {
                  this.filesToUpload.push(file);
                  formData.append('file[' + proposalIndex + '_' + index + ']', file);
                });
              }
            });

            const upload = axios.post(uploadUrl, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              },
              onUploadProgress: (progressEvent) => {
                this.fileUploadModal = true;
                const { loaded, total } = progressEvent;
                var loadPercent = Math.round((loaded * 100) / total);
                if (document.getElementsByClassName('file-progress-bar').length) {
                  document.getElementsByClassName('file-progress-bar')[0].style.width =
                    loadPercent + '%';
                }
              }
            });
            upload
              .then(() => {
                this.fileUploadModal = false;
                this.savePayment();
              })
              .catch(() => {});
          }
        } else {
          this.scrollToFirstError();
        }
      });
    },
    getOptions(proposal) {
      var options = [];
      for (var i in proposal) {
        options.push(proposal[i].Description);
      }
      return options;
    },
    //  TODO: FRONTEND STATICHTML ONLY
    saveSTATICHTML() {
      this.form.validate().then((result) => {
        if (result.valid) {
          setTimeout(() => {
            window.location = '/bekraeftelse.html';
          }, 500);
        } else {
          this.scrollToFirstError();
        }
      });
    }, // END
    coverEntry(cover) {
      let coverText = cover.Name;
      if (cover.AmountType || (cover.RenderingType === 1 && cover.Value)) {
        coverText += `: ${cover.Value}`;
      }
      return coverText;
    },
    // resetAll() {},
    getDanishProductTypeName(name) {
      let danishProductTypeName;
      switch (name) {
        case 'car':
          danishProductTypeName = 'bil';
          break;
        case 'personalaccident':
          danishProductTypeName = 'ulykke';
          break;
        case 'content':
          danishProductTypeName = 'indbo';
          break;
        case 'extendedtravel':
          danishProductTypeName = 'forlænget rejse';
          break;
        case 'pet':
          danishProductTypeName = 'hund';
          break;
        case 'boat':
          danishProductTypeName = 'lystfartøj';
          break;
        case 'othervehicle':
          danishProductTypeName = 'andet køretøj';
          break;
        case 'moped':
          danishProductTypeName = 'knallert';
          break;
        case 'caravan':
          danishProductTypeName = 'campingvogn';
          break;
        case 'motorcycle':
          danishProductTypeName = 'motorcykel';
          break;
        case 'house':
          danishProductTypeName = 'hus';
          break;
        case 'veteran':
          danishProductTypeName = 'veteran';
          break;
        case 'vacationhome':
          danishProductTypeName = 'sommerhus';
          break;
        case 'salaryprotection':
          danishProductTypeName = 'lønsikring';
          break;
        case 'construction':
          danishProductTypeName = 'entreprise';
          break;
        case 'health':
          danishProductTypeName = 'sundhed';
          break;
        case 'childaccident':
          danishProductTypeName = 'børneulykke';
          break;
        case 'mobility':
          danishProductTypeName = 'delebil';
          break;
        default:
          danishProductTypeName = '';
      }
      return danishProductTypeName;
    },
    getPaymentsPerYear(interValId) {
      let paymentsPerYear;
      switch (interValId) {
        case 1000009:
          paymentsPerYear = 1;
          break;
        case 1000007:
          paymentsPerYear = 2;
          break;
        case 1000008:
          paymentsPerYear = 4;
          break;
        case 1000006:
          paymentsPerYear = 12;
          break;
      }
      return paymentsPerYear;
    },
    dispatchEvent() {
      const proposals = this.vueModel.Data.Proposals;
      let productsArray = [];
      proposals.forEach((proposal) => {
        productsArray.push({
          name: proposal.Name,
          id: proposal.ProductType,
          price: Utility.getGoogleFriendlyPrice(proposal.Price),
          brand: Utility.getBrandIdentifier(),
          quantity: 1
        });
      });
      this.$store.dispatch('Events/register', {
        event: 'confirmation-page',
        id: 'ecommerce',
        vm: {
          purchase: {
            actionField: {
              id: this.vueModel.Data.TrackingId,
              revenue: Utility.getGoogleFriendlyPrice(this.vueModel.Data.TotalPrice),
              tax: Utility.getGoogleFriendlyPrice(this.vueModel.Data.TotalFees)
            },
            products: productsArray
          }
        }
      });
    },
    setShowConditionsCheckbox() {
      let i = 0;
      for (i; i <= this.vueModel.Data.Proposals.length; i++) {
        if (
          this.vueModel.Data &&
          this.vueModel.Data.Proposals[i] &&
          this.vueModel.Data.Proposals[i].Type &&
          (this.vueModel.Data.Proposals[i].Type === 'personalaccident' ||
            this.vueModel.Data.Proposals[i].Type === 'childaccident')
        ) {
          this.showAcceptConditions = true;
          break;
        }
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import 'src/styles/all.scss';
.file-progress-bar {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 1%;
}

.summary-final-disclaimer {
  margin-top: rem-calc(30);
  margin-bottom: rem-calc(30);
}
</style>
